export default {
  'доктор архитектуры': 'доктор архитектуры',
  'доктор биологических наук': 'доктор биологических наук',
  'доктор ветеринарных наук': 'доктор ветеринарных наук',
  'доктор военных наук': 'доктор военных наук',
  'географических наук': 'географических наук',
  'доктор геолого-минералогических наук': 'доктор геолого-минералогических наук',
  'доктор искусствоведения': 'доктор искусствоведения',
  'доктор исторических наук': 'доктор исторических наук',
  'доктор культурологии': 'доктор культурологии',
  'доктор медицинских наук': 'доктор медицинских наук',
  'доктор педагогических наук': 'доктор педагогических наук',
  'доктор политических наук': 'доктор политических наук',
  'доктор психологических наук': 'доктор психологических наук',
  'доктор социологических наук': 'доктор социологических наук',
  'доктор сельскохозяйственных наук': 'доктор сельскохозяйственных наук',
  'доктор технических наук': 'доктор технических наук',
  'доктор фармацевтических наук': 'доктор фармацевтических наук',
  'доктор физико-математических наук': 'доктор физико-математических наук',
  'доктор филологических наук': 'доктор филологических наук',
  'доктор философских наук': 'доктор философских наук',
  'доктор химических наук': 'доктор химических наук',
  'доктор экономических наук': 'доктор экономических наук',
  'доктор юридических наук': 'доктор юридических наук',
  'кандидат архитектуры': 'кандидат архитектуры',
  'кандидат биологических наук': 'кандидат биологических наук',
  'кандидат ветеринарных наук': 'кандидат ветеринарных наук',
  'кандидат военных наук': 'кандидат военных наук',
  'кандидат географических наук': 'кандидат географических наук',
  'кандидат геолого-минералогических наук': 'кандидат геолого-минералогических наук',
  'кандидат искусствоведения': 'кандидат искусствоведения',
  'кандидат исторических наук': 'кандидат исторических наук',
  'кандидат культурологии': 'кандидат культурологии',
  'кандидат медицинских наук': 'кандидат медицинских наук',
  'кандидат педагогических наук': 'кандидат педагогических наук',
  'кандидат политических наук': 'кандидат политических наук',
  'кандидат психологических наук': 'кандидат психологических наук',
  'кандидат социологических наук': 'кандидат социологических наук',
  'кандидат сельскохозяйственных наук': 'кандидат сельскохозяйственных наук',
  'кандидат технических наук': 'кандидат технических наук',
  'кандидат фармацевтических наук': 'кандидат фармацевтических наук',
  'кандидат физико-математических наук': 'кандидат физико-математических наук',
  'кандидат филологических наук': 'кандидат филологических наук',
  'кандидат философских наук': 'кандидат философских наук',
  'кандидат химических наук': 'кандидат химических наук',
  'кандидат экономических наук': 'кандидат экономических наук',
  'кандидат юридических наук': 'кандидат юридических наук',
  PhD: 'PhD',
};



// WEBPACK FOOTER //
// ./src/data/academic-degrees.js